import styles from './HeroSectionLight.module.css';
import { HeroSectionBottomRightRock, HeroSectionLeftRock, HeroSectionTopRightRock, } from '../../../assets/images/icons';
import { t } from 'i18next';

function HeroSectionLight({ title, desc, finish_callback, ...props }) {
    return (
        <div className={styles.container}>
            <img src={HeroSectionLeftRock} className={styles.HeroSectionCircle1} alt="Decorative rock on the left in the Hero section" />
            <img src={HeroSectionTopRightRock} className={styles.HeroSectionCircle2} alt="Decorative rock on the top-right in the Hero section" />
            <img src={HeroSectionBottomRightRock} className={styles.HeroSectionCircle3} alt="Decorative rock on the bottom-right in the Hero section" />
            <div className={`${styles.container} ${styles.contentWrapper}`}>
                <div className={styles.heroSectionCenter}>
                    <p className={styles.heroTitle}>{title ? title : t('general.UI.verificationTitle')}</p>
                    <p className={styles.heroDesc}>{desc ? desc : t('general.UI.verificationDesc')}</p>
                </div>
            </div>
        </div>
    );
}

export default HeroSectionLight;